import dynamic from "next/dynamic";

export const CarouselV2 = dynamic(() =>
  import("./carousel").then(({ CarouselV2 }) => CarouselV2)
);
